var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatio1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.79086 5.79086 8 8 8L24 8C26.2091 8 28 9.79086 28 12L28 20C28 22.2091 26.2091 24 24 24L8 24C5.79086 24 4 22.2091 4 20L4 12Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.75L9.25 13.25V18.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.25C12.5 16.4216 13.1716 15.75 14 15.75V15.75C14.8284 15.75 15.5 16.4216 15.5 17.25V17.25C15.5 18.0784 14.8284 18.75 14 18.75V18.75C13.1716 18.75 12.5 18.0784 12.5 17.25V17.25Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.25V14.75C12.5 13.9216 13.1716 13.25 14 13.25H15",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 14.5,
    r: 0.75,
    fill: "#898885"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 17.5,
    r: 0.75,
    fill: "#898885"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.75C24 15.5784 23.3284 16.25 22.5 16.25V16.25C21.6716 16.25 21 15.5784 21 14.75V14.75C21 13.9216 21.6716 13.25 22.5 13.25V13.25C23.3284 13.25 24 13.9216 24 14.75V14.75Z",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.75V17.25C24 18.0784 23.3284 18.75 22.5 18.75H21.5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatio1);
export default __webpack_public_path__ + "static/media/ratio1.92fe0e42b456824b718a3c5f20e29fac.svg";
export { ForwardRef as ReactComponent };